/**
 * Top of the shared rating scale: N/A, which orders the list and means nothing
 * more. Lives here rather than in `api/review-report.ts` so the review form can
 * import it — a value import from `api/*` blanks the app client-side.
 */
export const SCALE_NOT_APPLICABLE_ORDINAL = 6;
